export const kebabToWords = (str: string) => {
  return str
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Titleize a string
 * @param str - The string to titleize
 * @returns The titleized string
 */
export function titleize(str: string) {
  // return str.toLowerCase().replace(/(?:^|\s|-)\S/g, x => x.toUpperCase());
  return (
    str &&
    str
      .split(/(\s|-)/g)
      .filter(e => e !== '-' && e !== ' ' && e !== '')
      .map(elem => {
        return `${elem[0].toUpperCase()}${elem.substring(1)}`;
      })
      .join(' ')
  );
}

/**
 * Remove special characters from a string
 * @param str - The string to remove special characters from
 * @returns The string with special characters removed
 */
export function removeSpecialCharacters(str: string, replaceWith = '') {
  return str.replace(/[^a-zA-Z0-9]/g, replaceWith);
}

// Converts SanFrancisco to san-francisco
export const snakeCase = (string: string) => {
  return string
    .replace(/\W+/g, ' ')
    .split(/ |\B(?=[A-Z])/)
    .map(word => word.toLowerCase())
    .join('-');
};

export const urlize = (inString: string) =>
  decodeURI(inString)
    .trim()
    .toLowerCase()
    .replace(/_/g, '-')
    .replace(/[^\w\s-]+/g, '')
    .replace(/[\s-]+/g, ' ')
    .replace(/\s/g, '-');

const parseName = (name: string) => {
  const attrs: {
    fullName: string;
    firstName: string;
    lastName: string;
  } = {
    fullName: '',
    firstName: '',
    lastName: ''
  };

  if (!name) {
    return attrs;
  }

  let parts: string | string[] = name
    .trim()
    .replace(/\b\s+(,\s+)\b/, '$1')
    .replace(/\b,\b/, ', ');

  parts = (parts.match(/[^\s"]+|"[^"]+"/g) || parts.split(/\s+/)).map(n =>
    n.match(/^".*"$/) ? n.slice(1, -1) : n
  );

  if (!parts.length) {
    return attrs;
  }

  attrs.fullName = parts.join(' ');

  if (parts.length === 1) {
    attrs.firstName = parts[0];
  }

  if (parts.length > 1) {
    attrs.firstName = parts[0];
    attrs.lastName = parts.slice(1, name.length).join(' ');
  }

  for (const [k, v] of Object.entries(attrs)) {
    attrs[k as keyof typeof attrs] = v.trim();
  }
  return attrs;
};

export const getFullName = (
  firstName: string | undefined,
  lastName: string | undefined
) => {
  if (!firstName && !lastName) {
    return '';
  }
  return [firstName, lastName]?.filter(Boolean).join(' ');
};

const JSON_LD_ESCAPE: Record<string, string> = {
  '&': '\\u0026',
  '<': '\\u003c',
  '>': '\\u003e',
  '\u2028': '\\u2028',
  '\u2029': '\\u2029'
};

/**
 * JSON.stringify variant safe to inline inside a <script> element:
 * escapes HTML-significant characters so content-controlled strings
 * cannot break out via `</script>` or `<!--` sequences.
 */
export function jsonLdStringify(
  value: unknown,
  replacer?: (key: string, value: unknown) => unknown
): string {
  return JSON.stringify(value, replacer as never).replace(
    /[&<>\u2028\u2029]/g,
    match => JSON_LD_ESCAPE[match]
  );
}

export default parseName;
